import { useTranslation } from "react-i18next";
import { renderItem } from "./renderItem";
import { firstToUpper } from "../../../../../../../utils/helpers/string";

const fields = ["base", "worked"];

const HolidayRules = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="tooltip-content-style">
            <h3 className="font-weight-bolder text-left mb-1">{t("holiday-rules")}</h3>
            {data?.status && renderItem(data.status, "holiday-rule-status", t)}
            {fields.map((item, i) => {
                return (
                    data?.[item] && (
                        <div key={i}>
                            <div>
                                <h4
                                    className="mb-2 text-left"
                                    style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}
                                >
                                    {t(firstToUpper(item))}
                                </h4>
                                {data?.[item]?.status && renderItem(data[item].status, "status", t)}
                                {data?.[item]?.payCode && renderItem(data[item].payCode, "pay-code", t)}
                                {data?.[item]?.premiumPayCode &&
                                    renderItem(data[item].premiumPayCode, "premium-pay-code", t)}
                                {data?.[item]?.amount && renderItem(data[item].amount, "amount", t)}
                                {data?.[item]?.markedPayCode &&
                                    renderItem(data[item].markedPayCode, "marked-pay-code", t)}
                                {data?.[item]?.premiumMarkedPayCode &&
                                    renderItem(data[item].premiumMarkedPayCode, "premium-marked-pay-code", t)}
                                {data?.[item]?.hourTypes && renderItem(data[item].hourTypes, "hour-types", t)}
                            </div>
                        </div>
                    )
                );
            })}
        </div>
    );
};

export default HolidayRules;
